/**
 * Created by dok on 01/02/2017.
 */
angular.module('tf.controllers')

    .controller('CreateGroupController', ['$scope', 'FarmService', 'NotificationService', '$timeout', 'farm',
        function ($scope, FarmService, NotificationService, $timeout, farm) {

            $scope.settingsChanged = false;
            $scope.farm = farm;
            $scope.group = {};
            $scope.users = {
                users : []
            };

            setTimeout(function(){$('.modal input').first().focus();},1);

            $scope.createGroup = function(){
                $scope.isWorking = true;
                var emails = _.chain($scope.users.users).pluck('local').pluck('email').value();
                FarmService.createGroup($scope.group, emails).then(function () {
                    $scope.$close(true);
                });
            };


            var unwatch = $scope.$watch('group', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatch();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };
        }
    ]
);